module.exports = __webpack_public_path__ + "img/tours_8.2ab083e1.jpg";